const code = 'cosi';
const codeAPI = 'cosi';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};